import { createSlice } from '@reduxjs/toolkit';
import { createScopedStore, createIndependentStore } from '@utils/react';

function makeSitemapStore(partialSitemap) {
  const slice = createSlice({
    name: "@pm2/sitemap",
    initialState: {
      ...partialSitemap,
      notFoundPaths: partialSitemap.notFoundPaths ?? [],
      hasRenderedFirstPage: false,
      isSitemapResolved: false
    },
    reducers: {
      updatePartialSitemap(state, action) {
        state.rootDescriptors = action.payload.rootDescriptors;
        state.notFoundPaths = action.payload.notFoundPaths ?? [];
        state.searchPath = action.payload.searchPath;
        state.isSitemapResolved = true;
      },
      updatePageDescriptor(state, action) {
        state.rootDescriptors = recursivelyUpdatePageDescriptor(
          state.rootDescriptors,
          action.payload
        );
      },
      registerNotFoundPath(state, action) {
        state.notFoundPaths.push(action.payload);
      },
      registerPageRender(state) {
        state.hasRenderedFirstPage = true;
      }
    }
  });
  return createIndependentStore(slice);
}
function recursivelyUpdatePageDescriptor(parents, newPageDescriptor) {
  return parents.map((it) => {
    if (it.id === newPageDescriptor.id) {
      return newPageDescriptor;
    }
    if (it.children) {
      return {
        ...it,
        children: recursivelyUpdatePageDescriptor(
          it.children,
          newPageDescriptor
        )
      };
    }
    return it;
  });
}
const pm2SitemapStore = createScopedStore(
  makeSitemapStore({
    rootDescriptors: [],
    notFoundPaths: [],
    searchPath: "/soeg"
  })
);

export { makeSitemapStore, pm2SitemapStore };
//# sourceMappingURL=store.partial-sitemap.js.map
